import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import { PATHS } from "../../../constants/paths";

const UsersPage = lazy(() => import("../Users"));
const UserPage = lazy(() => import("../User"));

const UserOverviewTabPage = lazy(() => import("../tabs/OverviewTab"));
const UserCompaniesTabPage = lazy(() => import("../tabs/CompaniesTab"));

const useUsersRoutes = () => (
  <Route path={PATHS.Users.Path}>
    <Route path="" element={<UsersPage />} />
    <Route path={PATHS.Users.Page.User.Path} element={<UserPage />}>
      <Route
        path={PATHS.Users.Page.User.Tabs.OverviewTab.Path}
        element={<UserOverviewTabPage />}
      />
      <Route
        path={PATHS.Users.Page.User.Tabs.CompaniesTab.Path}
        element={<UserCompaniesTabPage />}
      />
      <Route
        index
        element={
          <Navigate replace to={PATHS.Users.Page.User.Tabs.OverviewTab.Path} />
        }
      />
    </Route>
  </Route>
);

export { useUsersRoutes };
